import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

const ConfirmApproval = ({ onClose, handleYes }) => {
  return (
    <Modal isOpen={true} centered size="md">
      <ModalHeader toggle={onClose} className="border-0 pb-0">
        <p className="fw-semibold fs-16">Send Approval </p>
      </ModalHeader>

      <ModalBody className="pt-3">
        <p className="mb-4"> Your configuration has been sent for approval, please check your dashboard for further updates</p>

        <div className="d-flex justify-content-between mb-4 gap-3">
          <Button color="white" style={{ fontSize: '14px', width: '224px', borderRadius: '5px', border: '1px solid #401589' }} onClick={onClose}>
            No
          </Button>

          <Button color="primary" style={{ fontSize: '14px', width: '224px', borderRadius: '5px' }} onClick={handleYes}>
            Yes
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmApproval;
